<div id="caseActionsHeader">
  <h3 class="headline-small">{{ 'caseActions.title' | translate }}</h3>
  <button mat-icon-button (click)="close()">
    <mat-icon class="material-symbols-outlined">close</mat-icon>
  </button>
</div>

<div id="caseActionsList">
  @if (loading()) {
    @for (i of [1, 2]; track i) {
      <div class="actionSkeleton skeletonPulse"></div>
    }
  } @else if (actions().length === 0) {
    <div id="caseActionsEmptyState">
      <mat-icon class="material-symbols-outlined">bolt</mat-icon>
      <p class="body-medium">{{ 'caseActions.emptyState' | translate }}</p>
    </div>
  } @else {
    @for (action of actions(); track action.name) {
      <button matButton="tonal" class="caseActionButton" (click)="onExecute(action)" [disabled]="executing()">
        <mat-icon class="material-symbols-outlined">bolt</mat-icon>
        {{ action.name }}
      </button>
    }
  }
</div>
